import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { fmtTRY } from "../../lib/format";
import { Button } from "../../components/ui/button";
import { Trash2, Package, ShoppingBag } from "lucide-react";

export default function Cart() {
  const { items, update, remove, totals } = useCart();
  if (items.length === 0) return (
    <div className="max-w-3xl mx-auto p-16 text-center">
      <ShoppingBag size={48} className="mx-auto text-zinc-300 mb-4" />
      <h1 className="font-display font-bold text-2xl text-zinc-900 mb-2">Sepetiniz boş</h1>
      <p className="text-zinc-500 mb-6">Alışverişe başlamak için ürünlere göz atın</p>
      <Button asChild className="bg-blue-600 hover:bg-blue-700"><Link to="/urunler">Ürünlere Git</Link></Button>
    </div>
  );

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <h1 className="font-display font-bold text-2xl text-zinc-900 mb-6">Sepetim ({items.length} ürün)</h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-3">
          {items.map(i => (
            <div key={i.stock_id} className="flex items-center gap-4 p-4 bg-white border border-zinc-200 rounded-lg" data-testid={`cart-item-${i.stock_id}`}>
              <div className="w-20 h-20 bg-zinc-50 rounded flex items-center justify-center overflow-hidden flex-shrink-0">
                {i.image ? <img src={i.image} alt="" className="w-full h-full object-cover"/> : <Package size={24} className="text-zinc-300"/>}
              </div>
              <div className="flex-1 min-w-0">
                {i.brand && <div className="text-xs text-zinc-500">{i.brand}</div>}
                <div className="font-medium text-zinc-900 truncate">{i.name}</div>
                <div className="text-xs font-mono text-zinc-400">#{i.code}</div>
              </div>
              <input type="number" min="1" value={i.quantity} onChange={(e) => update(i.stock_id, Math.max(1, Number(e.target.value)))} className="w-16 h-9 border border-zinc-200 rounded px-2 text-sm text-center" data-testid={`cart-qty-${i.stock_id}`} />
              <div className="text-right w-28 tabular-nums font-semibold">{fmtTRY(i.unit_price * i.quantity * (1 + i.vat_rate / 100))}</div>
              <Button size="icon" variant="ghost" onClick={() => remove(i.stock_id)}><Trash2 size={16} className="text-red-600" /></Button>
            </div>
          ))}
        </div>
        <div className="lg:col-span-1">
          <div className="bg-zinc-50 rounded-lg p-6 sticky top-24">
            <h3 className="font-semibold text-zinc-900 mb-4">Sipariş Özeti</h3>
            <div className="space-y-2 text-sm mb-4">
              <div className="flex justify-between"><span className="text-zinc-500">Ara Toplam</span><span className="tabular-nums">{fmtTRY(totals.net)}</span></div>
              <div className="flex justify-between"><span className="text-zinc-500">KDV</span><span className="tabular-nums">{fmtTRY(totals.vat)}</span></div>
              <div className="flex justify-between text-lg font-bold pt-3 border-t border-zinc-200"><span>Toplam</span><span className="tabular-nums text-blue-600">{fmtTRY(totals.gross)}</span></div>
            </div>
            <Button asChild size="lg" className="w-full bg-blue-600 hover:bg-blue-700" data-testid="cart-checkout"><Link to="/odeme">Siparişi Tamamla</Link></Button>
          </div>
        </div>
      </div>
    </div>
  );
}
